import { useQuery } from '@tanstack/react-query';
import { gridService } from '@/services/grid-service';

// Slowed from 3s to 60s — MSMQ requires a trip to a single EC2 instance and
// can't handle high-frequency polling from many concurrent Load users. Revisit
// once MSMQ→SQS migration (GLOB-632) is complete.
const ACTIVE_OPERATIONS_REFRESH_INTERVAL = 60000;

export function useGridData(companyId?: number, path?: string, hasActiveOperations?: boolean) {
  return useQuery({
    queryKey: ['gridData', companyId, path],
    queryFn: async () => {
      if (!companyId) {
        throw new Error('Company ID is required');
      }

      // Call the same API as Vue app
      // Note: Don't encode path here - URLSearchParams in grid-service handles encoding
      const currentPath = path || '';

      // TODO: determine parentIsApp from navigation metadata; default to false for now
      const parentIsApp = false;

      const data = await gridService.getGridData(companyId, currentPath, parentIsApp);

      return data;
    },
    enabled: Boolean(companyId),
    // Don't cache - always fetch fresh data
    staleTime: 0,
    gcTime: 0,
    // Don't retry on errors - just show empty state
    retry: false,
    // Auto-refresh grid when there are active operations
    refetchInterval: hasActiveOperations ? ACTIVE_OPERATIONS_REFRESH_INTERVAL : false,
  });
}
